import { render, staticRenderFns } from "./DomainsBudgetImport.vue?vue&type=template&id=68a50eda&scoped=true&"
import script from "./DomainsBudgetImport.vue?vue&type=script&lang=js&"
export * from "./DomainsBudgetImport.vue?vue&type=script&lang=js&"
import style0 from "./DomainsBudgetImport.vue?vue&type=style&index=0&id=68a50eda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a50eda",
  null
  
)

export default component.exports